import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Result, Space, Typography, Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAxios } from "../../hooks/hooks";
import { useParams } from "react-router-dom";
import config from "../../business/config.json"

const { Title, Paragraph } = Typography;

function ContractorDownloadPage(props) {
	const { id } = useParams();
	const axios = useAxios();
	const [step, setStep] = useState(1);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		setLoading(true);
		try {
			// Step 2: Log info to API
			let type = 'hazmat';
			try {
				const response = await axios.current.post(`/project/${id}/contractor-access/record-login`, {
					name: values.name,
					email: values.email,
					phone: values.phone,
					cm: values.cm,
				});
				// TODO Fix, quick workaround
				const row = Array.isArray(response.data) ? response.data[0] : null;
				if (row && row.short_name_category) {
					type = row.short_name_category.toLowerCase();
				}
			} catch (error) {
				console.error("Error logging info:", error);
			}

			// Trigger downloads
			const downloadUrls = [
				`${config.api_domain}/business/database/project/latex/hazmat/${id}/document.pdf`,
			];
			if (type !== 'hazmat') {
				downloadUrls.push(`${config.api_domain}/business/database/project/latex/${type}/${id}/document.pdf`);
			}

			downloadUrls.forEach((url, index) => {
				setTimeout(() => {
					const link = document.createElement('a');
					link.href = url;
					link.target = '_blank';
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}, index * 2000); // 1 second delay between downloads to avoid popup blockers
			});

			setStep(3);
		} catch (error) {
			console.error("Error logging info:", error);
			// Still proceed to step 3 or show error? Usually better to show success if it's just logging.
			setStep(3);
		} finally {
			setLoading(false);
		}
	};

	const handleClose = () => {
		window.close();
		// Fallback if window.close() is blocked
		window.location.href = "about:blank";
	};

	if (!id && step !== 3) {
		return (
			<div style={{ padding: '20px' }}>
				<Skeleton active />
			</div>
		);
	}

	return (
		<div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
			<PageHeader
				title="File Download"
				subTitle={id}
			/>

			{step === 1 && (
				<Card title="Enter Your Information">
					<Form
						form={form}
						layout="vertical"
						onFinish={onFinish}
					>
						<Form.Item
							label="Name"
							name="name"
							rules={[{ required: true, message: 'Please enter your name' }]}
						>
							<Input prefix={<FontAwesomeIcon icon="user" />} placeholder="Full Name" />
						</Form.Item>

						<Form.Item
							label="Email"
							name="email"
							rules={[
								{ required: true, message: 'Please enter your email' },
								{ type: 'email', message: 'Please enter a valid email' }
							]}
						>
							<Input prefix={<FontAwesomeIcon icon="envelope" />} placeholder="Email Address" />
						</Form.Item>

						<Form.Item
							label="Phone Number"
							name="phone"
							rules={[{ required: true, message: 'Please enter your phone number' }]}
						>
							<Input prefix={<FontAwesomeIcon icon="phone" />} placeholder="Phone Number" />
						</Form.Item>
						<Form.Item
							label="Company Name"
							name="cm"
							rules={[{ required: true, message: 'Please enter your company name' }]}
						>
							<Input prefix={<FontAwesomeIcon icon="building" />} placeholder="Company Name" />
						</Form.Item>

						<Form.Item>
							<Button type="primary" htmlType="submit" loading={loading} block>
								Submit & Download
							</Button>
						</Form.Item>
					</Form>
				</Card>
			)}

			{step === 3 && (
				<Result
					status="success"
					title="Thank You!"
					subTitle="Your information has been logged and your downloads should have started."
					extra={[
						<Button type="primary" key="close" onClick={handleClose} block>
							Close Application
						</Button>
					]}
				/>
			)}
		</div>
	);
}

export default ContractorDownloadPage;
